import {
  DetailActionbarButton,
  DetailContext,
  DetailMode,
  DetailToolbarButtonType,
} from '@eas/common-web';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import React, { useContext } from 'react';
import { useActivateDialog } from './dialog-actions/activate-hook';
import { useDeactivateDialog } from './dialog-actions/deactivate-hook';

export const useStyles = makeStyles(() => ({
  toolbarIndentLeft: {
    marginLeft: 10,
  },
}));

export function MinimalDistancesActionbar() {
  const { mode } = useContext(DetailContext);

  const { handleActivate, showActivateButton } = useActivateDialog();
  const { handleDeactivate, showDeactivateButton } = useDeactivateDialog();

  return (
    <>
      {mode === DetailMode.VIEW && (
        <div style={{ flexWrap: 'wrap' }}>
          {showActivateButton && (
            <DetailActionbarButton
              startIcon={<RefreshIcon fontSize="small" />}
              label="Obnovit platnost"
              onClick={handleActivate}
              type={DetailToolbarButtonType.PRIMARY}
            />
          )}
          {showDeactivateButton && (
            <DetailActionbarButton
              startIcon={<CloseIcon fontSize="small" />}
              label="Zneplatnit"
              onClick={handleDeactivate}
              type={DetailToolbarButtonType.SECONDARY}
            />
          )}
        </div>
      )}
    </>
  );
}
